module.exports = __webpack_public_path__ + "img/catch03.de720d8e.png";